AFRAME.registerComponent('news-graph-overview-vr', {
    init: function () {
        this.render = this.render.bind(this);
        
        this.titleText = 'Overview';
        this.summaryText = 'Loading overview...';
        this.currentSummaryTitle = 'Summary:';
        this.currentSummaryText = 'Loading overview...';
        this.activeNewsUrl = null;
        this.defaultOverviewText = '';
        this.stocksData = [];
        this.newsData = [];
        this.historyStack = [];
        
        this.render();

        this.onNodeClicked = this.onNodeClicked.bind(this);
        this.el.sceneEl.addEventListener('theme-changed', this.render);
        this.el.sceneEl.addEventListener('news-graph-node-clicked', this.onNodeClicked);

        this.fetchData();
    },
    fetchData: function () {
        if (!window.NewsProxyAPIManager) return;
        const proxy = new window.NewsProxyAPIManager();
        proxy.fetchNarrativeTickerMap()
            .then(data => {
                if (data) {
                    let text = 'No overview available.';
                    if (data.overview && data.overview.market) {
                        text = data.overview.market;
                    } else if (data.overview && data.overview.overview) {
                        text = data.overview.overview;
                    } else if (typeof data.overview === 'string') {
                        text = data.overview;
                    }
                    this.defaultOverviewText = text;
                    this.summaryText = text;
                    this.currentSummaryTitle = 'Summary:';
                    this.currentSummaryText = text;
                    this.activeNewsUrl = null;
                    this.titleText = 'Overview';
                    this.stocksData = [];
                    this.newsData = [];
                    this.render();
                }
            })
            .catch(err => {
                this.overviewText = 'Error loading overview.';
                this.render();
                console.error("Overview data error", err);
            });
    },
    remove: function () {
        this.el.sceneEl.removeEventListener('theme-changed', this.render);
        this.el.sceneEl.removeEventListener('news-graph-node-clicked', this.onNodeClicked);
    },
    _isLightMode: function() {
        if (typeof getCacheItem === 'function') {
            const settings = getCacheItem('mainSettings');
            if (settings && settings.themeMode) {
                return settings.themeMode === 'Light';
            }
        }
        return false;
    },
    onNodeClicked: function(e) {
        const { node, data } = e.detail;

        this.historyStack = [];

        if (!node || !data) {
            this.titleText = 'Overview';
            this.summaryText = this.defaultOverviewText || 'No overview available.';
            this.currentSummaryTitle = 'Summary:';
            this.currentSummaryText = this.summaryText;
            this.activeNewsUrl = null;
            this.stocksData = [];
            this.newsData = [];
            this.render();

            this.el.setAttribute('visible', 'true');
            return;
        }

        let relatedTickers = [];
        let articleIds = [];
        let summaryText = '';

        if (window.NewsGraph && window.NewsGraph.NARRATIVE_TYPES && window.NewsGraph.NARRATIVE_TYPES.has(node.type)) {
            relatedTickers = [...(node.affected_assets || []), ...(node.tickers || [])];
            articleIds = node.article_ids || [];
            summaryText = node.summary || node.description || '';
        } else {
            relatedTickers = node.grouped_tickers || [node.symbol || node.label];
            articleIds = node.article_ids || [];
            const narrative = (data.narratives || []).find(n => [...(n.tickers||[]), ...(n.affected_assets||[])].includes(node.id || node.symbol));
            if (narrative) {
                summaryText = narrative.summary || narrative.description || '';
            } else {
                for (const aid of articleIds.slice(0, 3)) {
                    const a = data.articles && data.articles[aid];
                    if (a && (a.text || a.summary)) {
                        summaryText = a.text || a.summary;
                        break;
                    }
                }
            }
        }

        relatedTickers = [...new Set(relatedTickers)].slice(0, 3);

        const relatedEntries = window.NewsGraph.buildRelatedTopicsData(node, data);

        this.newsData = relatedEntries.slice(0, 3).map(({ item, isTicker }) => {
            if (isTicker) {
                const symbol = item.symbol || item.id;
                const name = item.name || '';
                let title = name ? `${symbol} - ${name}` : symbol;
                return {
                    id: item.id,
                    title: title,
                    text: item.summary || 'No summary available.',
                    url: null,
                    isTicker: true
                };
            } else {
                return {
                    id: item.id,
                    title: item.short_label || item.title || item.label || item.id,
                    text: item.summary || item.description || 'No summary available.',
                    url: null,
                    isTicker: false
                };
            }
        });

        const priceMap = data ? window.NewsProxyAPIManager.buildTickerPriceMap(data) : null;
        const displayTickers = relatedTickers;
        this.stocksData = displayTickers.map(sym => {
            const cleanSym = String(sym).toUpperCase();
            const entry = priceMap ? priceMap.get(cleanSym) : null;
            return {
                sym,
                pct: entry?.changePct ?? null,
                price: entry?.price ?? null
            };
        });
        this.currentStocksPage = 0;
        this.currentTopicsPage = 0;

        if (node.type === 'ticker' || node.type === 'ticker_group' || node.symbol) {
            const sym = node.symbol || node.label || node.group_label || node.name || node.id || 'Details';
            this.titleText = String(sym).split(' - ')[0].trim().toUpperCase();
        } else {
            this.titleText = node.short_label || node.label || node.title || node.name || node.id || 'Details';
            this.titleText = this.titleText.length > 40 ? this.titleText.slice(0, 40) + '…' : this.titleText;
        }
        
        this.summaryText = summaryText || 'No details available.';
        this.currentSummaryTitle = 'Summary:';
        this.currentSummaryText = this.summaryText;
        this.activeNewsUrl = null;
        this.render();

        this.el.setAttribute('visible', 'true');
    },
    createAIBadge: function (isLight) {
        const badgeBg = document.createElement('a-rounded-plane');
        badgeBg.setAttribute('width', '0.08');
        badgeBg.setAttribute('height', '0.04');
        badgeBg.setAttribute('radius', '0.008');
        badgeBg.setAttribute('color', isLight ? '#e5e7eb' : '#2d3748');
        
        const badgeText = document.createElement('a-troika-text');
        badgeText.setAttribute('value', 'AI');
        badgeText.setAttribute('font-size', '0.022');
        badgeText.setAttribute('font-weight', 'bold');
        badgeText.setAttribute('align', 'center');
        badgeText.setAttribute('anchor', 'center');
        badgeText.setAttribute('baseline', 'center');
        badgeText.setAttribute('color', isLight ? '#1f2937' : '#9ca3af');
        badgeText.setAttribute('position', '0.04 0.02 0.002');
        
        badgeBg.appendChild(badgeText);
        return badgeBg;
    },
    render: function () {
        this.el.innerHTML = '';

        const isLight = this._isLightMode();
        const textColor = isLight ? '#111827' : '#ffffff';

        const titlePos = '-0.6 0.5 0.01';

        const title = document.createElement('a-troika-text');
        title.setAttribute('value', this.titleText);
        title.setAttribute('font-size', '0.07');
        title.setAttribute('font-weight', 'bold');
        title.setAttribute('align', 'left');
        title.setAttribute('anchor', 'left');
        title.setAttribute('baseline', 'top');
        title.setAttribute('position', titlePos);
        title.setAttribute('color', textColor);
        this.el.appendChild(title);

        const aiBadge = this.createAIBadge(isLight);
        if (this.titleText === 'Overview') {
            aiBadge.setAttribute('position', '0.55 0.48 0.01');
        } else {
            aiBadge.setAttribute('position', '0.55 0.33 0.01');
        }
        this.el.appendChild(aiBadge);

        const textEl = document.createElement('a-troika-text');
        textEl.setAttribute('value', this.currentSummaryTitle + '\n' + this.currentSummaryText);
        textEl.setAttribute('font-size', '0.04');
        textEl.setAttribute('align', 'left');
        textEl.setAttribute('anchor', 'left');
        textEl.setAttribute('baseline', 'top');
        textEl.setAttribute('max-width', '1.2');
        textEl.setAttribute('line-height', '1.3');
        textEl.setAttribute('position', `-0.6 0.35 0.01`);
        textEl.setAttribute('color', textColor);
        this.el.appendChild(textEl);

        let currentY = -0.1;

        if (this.activeNewsUrl) {
            const readBtn = document.createElement('a-entity');
            readBtn.setAttribute('ui-button', {
                label: 'Read full article',
                type: 'rounded-box',
                width: 0.5,
                height: 0.12,
                depth: 0.01,
                colorScheme: 'primary',
                radius: 0.03,
                preferredFontSize: 0.05
            });
            readBtn.setAttribute('position', `0 ${currentY} 0.01`);
            readBtn.setAttribute('data-raycastable', '');
            readBtn.addEventListener('click', () => {
                window.open(this.activeNewsUrl, '_blank');
            });
            this.el.appendChild(readBtn);
            currentY -= 0.15;
        }

        if (this.stocksData && this.stocksData.length > 0) {
            currentY -= 0.05;
            const stocksTitle = document.createElement('a-troika-text');
            stocksTitle.setAttribute('value', 'Related stocks: ');
            stocksTitle.setAttribute('font-size', '0.045');
            stocksTitle.setAttribute('font-weight', 'bold');
            stocksTitle.setAttribute('anchor', 'left');
            stocksTitle.setAttribute('baseline', 'top');
            stocksTitle.setAttribute('position', `-0.6 ${currentY} 0.01`);
            stocksTitle.setAttribute('color', textColor);
            this.el.appendChild(stocksTitle);

            const itemsPerPage = 4;
            this.currentStocksPage = this.currentStocksPage || 0;
            const totalPages = Math.ceil(this.stocksData.length / itemsPerPage);

            const startIdx = this.currentStocksPage * itemsPerPage;
            const pageStocks = this.stocksData.slice(startIdx, startIdx + itemsPerPage);

            let rowCount = 0;
            let colCount = 0;
            const colWidth = 0.5;
            const rowHeight = 0.13;

            pageStocks.forEach((stock) => {
                const btn = document.createElement('a-entity');
                const posX = -0.25 + (colCount * colWidth);
                const posY = currentY - 0.12 - (rowCount * rowHeight);
                
                const pct = stock.pct;
                const price = stock.price;
                let pctStr = '';
                let dollarStr = '';
                let isPositive = true;
                let hasChange = false;

                if (pct !== null) {
                    hasChange = true;
                    isPositive = pct >= 0;
                    pctStr = `${isPositive ? '+' : ''}${pct.toFixed(1)}%`;
                    
                    const chgDollar = (price !== null && price > 0)
                        ? price - (price / (1 + pct / 100))
                        : null;
                    if (chgDollar !== null) {
                        dollarStr = `${isPositive ? '+' : '-'}$${Math.abs(chgDollar).toFixed(2)}`;
                    }
                }

                let changeText = '';
                let changeColor = textColor;
                if (hasChange) {
                    changeColor = isPositive ? '#10B981' : '#EF4444';
                    if (dollarStr) {
                        changeText = `${dollarStr} (${pctStr})`;
                    } else {
                        changeText = pctStr;
                    }
                }

                btn.setAttribute('ui-button', {
                    label: '',
                    type: 'rounded-box',
                    width: 0.48,
                    height: 0.1,
                    depth: 0.01,
                    colorScheme: 'primary',
                    radius: 0.02
                });
                btn.setAttribute('position', `${posX} ${posY} 0.01`);
                btn.setAttribute('data-raycastable', '');

                const symText = document.createElement('a-troika-text');
                symText.setAttribute('value', stock.sym);
                symText.setAttribute('color', textColor);
                symText.setAttribute('font-size', '0.035');
                symText.setAttribute('font-weight', 'bold');
                symText.setAttribute('baseline', 'center');

                if (changeText) {
                    symText.setAttribute('align', 'left');
                    symText.setAttribute('anchor', 'left');
                    symText.setAttribute('position', `-0.2 0 0.011`);

                    const chgText = document.createElement('a-troika-text');
                    chgText.setAttribute('value', changeText);
                    chgText.setAttribute('color', changeColor);
                    chgText.setAttribute('font-size', '0.03');
                    chgText.setAttribute('align', 'right');
                    chgText.setAttribute('anchor', 'right');
                    chgText.setAttribute('baseline', 'center');
                    chgText.setAttribute('position', `0.2 0 0.011`);
                    btn.appendChild(chgText);
                } else {
                    symText.setAttribute('align', 'center');
                    symText.setAttribute('anchor', 'center');
                    symText.setAttribute('position', `0 0 0.011`);
                }

                btn.appendChild(symText);

                btn.addEventListener('click', () => {
                    const cleanSym = String(stock.sym).toUpperCase();
                    const scene = this.el.sceneEl || document.querySelector('a-scene');
                    const tickerNewsEl = scene ? (scene.querySelector('[ticker-news]') || document.querySelector('[ticker-news]')) : null;
                    if (tickerNewsEl && tickerNewsEl.components && tickerNewsEl.components['ticker-news']) {
                        tickerNewsEl.components['ticker-news'].openTickerFromPill(cleanSym);
                    } else {
                        const searchModeEl = document.querySelector('[search-mode]') || document.querySelector('.search-container');
                        if (searchModeEl && searchModeEl.components && searchModeEl.components['search-mode']) {
                            const stockObj = {
                                ticker: cleanSym,
                                primary_exchange: 'Unknown Exchange'
                            };
                            searchModeEl.components['search-mode'].enterSearchMode(stockObj);
                        }
                    }
                });

                this.el.appendChild(btn);

                colCount++;
                if (colCount >= 2) {
                    colCount = 0;
                    rowCount++;
                }
            });

            currentY -= 0.12 + (Math.ceil(pageStocks.length / 2) * rowHeight) + 0.02;

            if (totalPages > 1) {
                const prevBtn = document.createElement('a-entity');
                prevBtn.setAttribute('ui-button', { label: '<', type: 'rounded-box', width: 0.1, height: 0.06, depth: 0.01, colorScheme: 'primary', radius: 0.01, preferredFontSize: 0.04 });
                prevBtn.setAttribute('position', `-0.15 ${currentY} 0.01`);
                prevBtn.setAttribute('data-raycastable', '');
                prevBtn.addEventListener('click', () => {
                    this.currentStocksPage = (this.currentStocksPage - 1 + totalPages) % totalPages;
                    this.render();
                });
                this.el.appendChild(prevBtn);
                
                const pageLabel = document.createElement('a-troika-text');
                pageLabel.setAttribute('value', `${this.currentStocksPage + 1} / ${totalPages}`);
                pageLabel.setAttribute('font-size', '0.04');
                pageLabel.setAttribute('align', 'center');
                pageLabel.setAttribute('anchor', 'center');
                pageLabel.setAttribute('baseline', 'center');
                pageLabel.setAttribute('position', `0 ${currentY} 0.01`);
                pageLabel.setAttribute('color', textColor);
                this.el.appendChild(pageLabel);

                const nextBtn = document.createElement('a-entity');
                nextBtn.setAttribute('ui-button', { label: '>', type: 'rounded-box', width: 0.1, height: 0.06, depth: 0.01, colorScheme: 'primary', radius: 0.01, preferredFontSize: 0.04 });
                nextBtn.setAttribute('position', `0.15 ${currentY} 0.01`);
                nextBtn.setAttribute('data-raycastable', '');
                nextBtn.addEventListener('click', () => {
                    this.currentStocksPage = (this.currentStocksPage + 1) % totalPages;
                    this.render();
                });
                this.el.appendChild(nextBtn);

                currentY -= 0.08;
            }
        }

        if (this.newsData && this.newsData.length > 0) {
            currentY -= 0.02;
            const topicsTitle = document.createElement('a-troika-text');
            topicsTitle.setAttribute('value', 'Related Topics');
            topicsTitle.setAttribute('font-size', '0.045');
            topicsTitle.setAttribute('font-weight', 'bold');
            topicsTitle.setAttribute('anchor', 'left');
            topicsTitle.setAttribute('baseline', 'top');
            topicsTitle.setAttribute('position', `-0.6 ${currentY} 0.01`);
            topicsTitle.setAttribute('color', textColor);
            this.el.appendChild(topicsTitle);

            const itemsPerPage = 1;
            this.currentTopicsPage = this.currentTopicsPage || 0;
            const totalPages = Math.ceil(this.newsData.length / itemsPerPage);

            currentY -= 0.12;

            const startIdx = this.currentTopicsPage * itemsPerPage;
            const pageTopics = this.newsData.slice(startIdx, startIdx + itemsPerPage);

            pageTopics.forEach(news => {
                const btn = document.createElement('a-entity');
                let displayTitle = news.title;
                if (displayTitle.length > 35) displayTitle = displayTitle.slice(0, 35) + '...';
                
                btn.setAttribute('ui-button', {
                    label: displayTitle,
                    type: 'rounded-box',
                    width: 0.9,
                    height: 0.08,
                    depth: 0.01,
                    colorScheme: 'primary',
                    radius: 0.02,
                    preferredFontSize: 0.035
                });
                btn.setAttribute('position', `0 ${currentY} 0.01`);
                btn.setAttribute('data-raycastable', '');

                btn.addEventListener('click', () => {
                    if (!this.historyStack) {
                        this.historyStack = [];
                    }
                    this.historyStack.push({
                        currentSummaryTitle: this.currentSummaryTitle,
                        currentSummaryText: this.currentSummaryText,
                        activeNewsUrl: this.activeNewsUrl
                    });

                    this.currentSummaryTitle = news.url ? 'News Summary:' : 'Topic Summary:';
                    this.currentSummaryText = news.text || news.title || 'No summary available.';
                    if (this.currentSummaryText.length > 400) {
                        this.currentSummaryText = this.currentSummaryText.slice(0, 400) + '...';
                    }
                    this.activeNewsUrl = news.url;
                    this.render();
                });
                
                this.el.appendChild(btn);
            });

            currentY -= 0.1;

            if (totalPages > 1) {
                const prevBtn = document.createElement('a-entity');
                prevBtn.setAttribute('ui-button', { label: '<', type: 'rounded-box', width: 0.1, height: 0.06, depth: 0.01, colorScheme: 'primary', radius: 0.01, preferredFontSize: 0.04 });
                prevBtn.setAttribute('position', `-0.15 ${currentY} 0.01`);
                prevBtn.setAttribute('data-raycastable', '');
                prevBtn.addEventListener('click', () => {
                    this.currentTopicsPage = (this.currentTopicsPage - 1 + totalPages) % totalPages;
                    this.render();
                });
                this.el.appendChild(prevBtn);
                
                const pageLabel = document.createElement('a-troika-text');
                pageLabel.setAttribute('value', `${this.currentTopicsPage + 1} / ${totalPages}`);
                pageLabel.setAttribute('font-size', '0.04');
                pageLabel.setAttribute('align', 'center');
                pageLabel.setAttribute('anchor', 'center');
                pageLabel.setAttribute('baseline', 'center');
                pageLabel.setAttribute('position', `0 ${currentY} 0.01`);
                pageLabel.setAttribute('color', textColor);
                this.el.appendChild(pageLabel);

                const nextBtn = document.createElement('a-entity');
                nextBtn.setAttribute('ui-button', { label: '>', type: 'rounded-box', width: 0.1, height: 0.06, depth: 0.01, colorScheme: 'primary', radius: 0.01, preferredFontSize: 0.04 });
                nextBtn.setAttribute('position', `0.15 ${currentY} 0.01`);
                nextBtn.setAttribute('data-raycastable', '');
                nextBtn.addEventListener('click', () => {
                    this.currentTopicsPage = (this.currentTopicsPage + 1) % totalPages;
                    this.render();
                });
                this.el.appendChild(nextBtn);

                currentY -= 0.1;
            }
        }
    }
});

export function mountOverviewPanel() {
    const rightPanel = document.querySelector('#right-container');
    if (rightPanel) {
        let rightOverview = rightPanel.querySelector('#news-graph-overview-vr-right');
        if (!rightOverview) {
            rightOverview = document.createElement('a-entity');
            rightOverview.classList.add('news-overview-tab');
            rightOverview.setAttribute('id', 'news-graph-overview-vr-right');
            const rcScale = rightPanel.object3D.scale;
            const invScaleX = 1 / (rcScale.x || 5.6);
            const invScaleY = 1 / (rcScale.y || 3.6);
            rightOverview.setAttribute('scale', `${invScaleX} ${invScaleY} 1`);
            rightOverview.setAttribute('position', '0 0.04 0.02'); 
            rightOverview.setAttribute('news-graph-overview-vr', '');
            rightOverview.setAttribute('visible', 'true');
            rightPanel.appendChild(rightOverview);
        } else {
            const comp = rightOverview.components && rightOverview.components['news-graph-overview-vr'];
            if (comp) {
                comp.titleText = 'Overview';
                comp.currentSummaryTitle = 'Summary:';
                comp.currentSummaryText = comp.defaultOverviewText || 'Loading overview...';
                comp.activeNewsUrl = null;
                comp.stocksData = [];
                comp.newsData = [];
                comp.historyStack = [];
                comp.render();
            }
            rightOverview.setAttribute('visible', 'true');
        }
    }
}
